import * as Yup from 'yup'

export const sponsorSchema = Yup.object().shape({
    purposeObjectives: Yup.string().required('Purpose and Objectives is required')
        .typeError('Purpose and Objectives is required'),
    programDetails: Yup.string().required('Course/Program is required')
        .typeError('Course/Program is required'),
    paymentOccurrence: Yup.string().required('Payment occurrence is required')
        .typeError('Payment occurrence is required'),
    paymentType: Yup.string().required('Payment type is required')
        .typeError('Payment type is required'),
    sponsorshipAmount: Yup.string().required('Total sponsorship amount is required')
        .typeError('Total sponsorship amount is required'),
    numberOfSlots: Yup.string().required('Total No of Beneficiaries required')
        .typeError('Total No of Beneficiaries Required'),
    amount: Yup.string().required('Course Amount Required')
        .typeError('Course Amount Required'),
    letterOfReference: Yup.mixed().test('fileSize', 'File size is too large', (value) => {
        if (!value || !value[0]) return true; // No file selected is valid
        return value[0].size <= 2 * 1024 * 1024; // 2MB
    }),
    interestRate: Yup.number().when('paymentType', {
        is: 'loan',
        then: Yup.number().required('Interest rate is required'),
        otherwise: Yup.number()
    }),
    recoveryAmount: Yup.number().when('paymentType', {
        is: 'loan',
        then: Yup.number().required('Recovery Amount is required'),
        otherwise: Yup.number()
    }),
    loanTerm: Yup.number().when('paymentType', {
        is: 'loan',
        then: Yup.number().required('Loan Term is required'),
        otherwise: Yup.number()
    }),
    startDate: Yup.date().when('paymentType', {
        is: 'loan',
        then: Yup.date().required('Start Date is required'),
        otherwise: Yup.date()
    }),
    endDate: Yup.date().when('paymentType', {
        is: 'loan',
        then: Yup.date().required('End Date is required')
            .typeError('End date must be a valid date')
            .nullable()
            .when('startDate', (startDate, schema) => {
                return startDate && schema.min(startDate, 'End date must be after start date');
            }),
        otherwise: Yup.date()
    }),
    recoveryOccurrence: Yup.string().when('paymentType', {
        is: 'loan',
        then: Yup.string().required('Loan Term is required'),
        otherwise: Yup.string()
    }),
})
